import { CbhFeatureFlag, useCbhFlag } from "../FeatureFlags";

export function useLicenseNumberRequirementsFlag() {
  return useCbhFlag(CbhFeatureFlag.HCP_LICENSE_NUMBER_REQUIREMENTS, {
    defaultValue: {},
  });
}
